export const addLogItem = (log: string) =>
  ({ type: 'log.AddLogItem', payload: { log } } as const)
export type AddLogItemAction = ReturnType<typeof addLogItem>

export const addLogItems = (log: string[]) =>
  ({ type: 'log.AddLogItems', payload: { log } } as const)
export type AddLogItemsAction = ReturnType<typeof addLogItems>

export const clearLogItems = (logIds: number[]) =>
  ({ type: 'log.ClearLogItems', payload: { logIds } } as const)
export type ClearLogItemsAction = ReturnType<typeof clearLogItems>

export const writeLogItems = () => ({ type: 'log.WriteLogItems' } as const)
export type WriteLogItemsAction = ReturnType<typeof writeLogItems>

export const noLogItems = () => ({ type: 'log.NoLogItems' } as const)
export type NoLogItemsAction = ReturnType<typeof noLogItems>

export type LogAction =
  | AddLogItemAction
  | AddLogItemsAction
  | ClearLogItemsAction
  | WriteLogItemsAction
  | NoLogItemsAction
